import { isAtExtreme } from "../../../helper/rangeFilter";

/** Applied single/custom chip values stay compact in the toolbar. */
export const MAX_CHIP_VALUE_LENGTH = 15;
const EN_DASH = "\u2013";

export const truncateValue = (text, maxLength = MAX_CHIP_VALUE_LENGTH) => {
  const value = String(text ?? "").trim();
  return value.length > maxLength ? `${value.slice(0, maxLength - 1)}\u2026` : value;
};

const inactive = (label) => ({
  label,
  displayLabel: label,
  valueLabel: "",
  isActive: false,
  count: 0,
  variant: "empty",
});

/**
 * Mobbin-style applied filter summaries:
 * - empty  → label + chevron
 * - single → truncated value only (full value in valueLabel for sidebar)
 * - multi  → label + count badge (no chevron)
 */
export const summarizeSelection = (label, ...valueGroups) => {
  const values = valueGroups.flat().filter((value) => value != null && String(value).trim() !== "");
  if (values.length === 0) return inactive(label);
  if (values.length === 1) {
    const raw = String(values[0]).trim();
    return {
      label: `${label}: ${raw}`,
      displayLabel: truncateValue(raw),
      valueLabel: raw,
      isActive: true,
      count: 1,
      variant: "single",
    };
  }
  return {
    label: `${label} (${values.length})`,
    displayLabel: label,
    valueLabel: "",
    isActive: true,
    count: values.length,
    variant: "multi",
  };
};

export const summarizeRange = (label, lowerBound, upperBound, scale) => {
  const hasLower = !isAtExtreme(lowerBound, scale.min);
  const hasUpper = !isAtExtreme(upperBound, scale.max);
  if (!hasLower && !hasUpper) return inactive(label);

  let value;
  if (hasLower && hasUpper) {
    value = `${scale.format(lowerBound)} ${EN_DASH} ${scale.format(upperBound)}`;
  } else {
    value = hasLower ? `${scale.format(lowerBound)}+` : `Up to ${scale.format(upperBound)}`;
  }

  return {
    label: `${label}: ${value}`,
    displayLabel: truncateValue(value),
    valueLabel: value,
    isActive: true,
    count: 1,
    variant: "single",
  };
};

export const summarizeText = (label, text) => {
  const value = String(text ?? "").trim();
  if (value === "") return inactive(label);
  return {
    label: `${label}: ${value}`,
    displayLabel: truncateValue(value),
    valueLabel: value,
    isActive: true,
    count: 1,
    variant: "single",
  };
};
